import React, { useState, useEffect, useCallback, useRef } from "react";

const TextInput = ({ 
  value, 
  defaultValue, 
  afterChange, 
  onChange: externalOnChange,
  debounceMs = 300, 
  className = "", 
  ...rest 
}) => {
  const [localValue, setLocalValue] = useState(value ?? defaultValue ?? "");
  const debounceTimer = useRef(null);

  useEffect(() => {
    if (value !== undefined) {
      setLocalValue(value);
    }
  }, [value]);

  useEffect(() => {
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, []);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);

    if (externalOnChange) {
      externalOnChange(e);
    }

    // TODO: Actually check if this is used
    if (afterChange) {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
      debounceTimer.current = setTimeout(() => {
        afterChange(newValue);
      }, debounceMs);
    }
  };

  return (
    <input
      type="text"
      autoComplete="off"
      {...rest}
      className={`form-control ${className}`}
      value={localValue}
      onChange={handleChange}
    />
  );
};

export default TextInput;